const createSelectOptions = (options: string[]) => {
    return options.map(item => ({
        label: item,
        value: item
    }))
}

export default createSelectOptions;